/**
 * NotificationAvatar
 *
 * Circular user avatar used as the leading slot of most notification rows,
 * ported from Flutter's `CircleBorderAvatar` with
 * `TextUtils.generateUserProfileImageUrl(userId)`
 * (e.g. `notification_content_like_item.dart:91-97`). Web sizing mirrors the
 * wallet row `GiftTransactionItem.tsx` (`responsive.avatar.medium`).
 */
import React from 'react';
import { CachedImage } from '@/presentation/components/common/CachedImage';
import { UserUtils } from '@/domain/utils/userUtils';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';

export interface NotificationAvatarProps {
  /** Firebase id used to build the profile-image URL (Flutter `usersInfo.userId`). */
  userId: string;
  alt?: string;
}

export const NotificationAvatar: React.FC<NotificationAvatarProps> = ({ userId, alt }) => {
  const responsive = useResponsiveDesign();

  return (
    <CachedImage
      src={UserUtils.generateUserProfileImageUrl(userId)}
      alt={alt ?? ''}
      style={{
        width: responsive.avatar.medium,
        height: responsive.avatar.medium,
        borderRadius: responsive.borderRadius.round,
        objectFit: 'cover',
      }}
    />
  );
};
